import { createCssCompNode } from '../cssCompNode'
import type { Component } from '@wix/thunderbolt-becky-types'
import type { FeatureRefs } from '../cssFeatures.types'
import { toCompVariants } from '../../utils/toCompVariants'
import { isRefArray } from '../../utils/variantsUtils'

export const transformationsVariants = createCssCompNode('transformations', 'transformationsVariants', {
	getDependencies: (component: Component, refs: FeatureRefs<'transformations'>) =>
		component.transformationQuery ? refs.transformationQuery(component.transformationQuery) : undefined,
	toViewItem: (__, transformationRefArray) => {
		if (!isRefArray(transformationRefArray)) {
			return null
		}

		return toCompVariants(transformationRefArray.values)
	},
})
